import { render, staticRenderFns } from "./aChmRowAvailability.vue?vue&type=template&id=bafff948&scoped=true"
import script from "./aChmRowAvailability.vue?vue&type=script&lang=js"
export * from "./aChmRowAvailability.vue?vue&type=script&lang=js"
import style0 from "./aChmRowAvailability.vue?vue&type=style&index=0&id=bafff948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafff948",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VCol,VIcon,VRow,VTooltip,VWindow,VWindowItem})
